<template>
  <div>
    <p
      v-if="mostrarUltimoStatus && !transportadoraOutros"
      class="d-flex"
      :class="`${corStatusRastreio}--text`"
    >
      <v-icon
        v-if="loadingRastreio"
        small
        class="grey--text ml-2"
      >
        fas fa-circle-notch fa-spin
      </v-icon>

      <template v-else>
        <v-icon
          class="mr-2"
          :color="corStatusRastreio"
        >
          {{ iconeStatusRastreio }}
        </v-icon>
        <span data-cy="status_rastreio">
          {{ ultimoStatusRastreio }}
        </span>
      </template>
    </p>

    <v-alert
      v-if="mostrarUltimoStatus"
      class="mb-4"
      color="info"
      dark
      dense
      data-cy="informacao_prazo_de_entrega"
    >
      <template v-if="transportadoraOutros">
        O serviço de rastreio da <strong>{{ transportadoraNome }}</strong>
        não foi disponibilizado em nossa plataforma. Para maiores informações, entre em
        contato com a transportadora sobre a sua entrega.
      </template>
      <template v-else>
        O código de rastreio foi gerado! Você pode acompanhar o trajeto da encomenda pela
        transportadora <strong>{{ transportadoraNome }}</strong>
      </template>

      <v-btn
        text
        block
        class="pa-0 my-2 white--text"
        data-cy="btn_codigo_rastreio"
        @click="copiarCodigoRastreio"
      >
        <v-icon class="mr-2">
          mdi-content-copy
        </v-icon>
        <v-text-field
          ref="codigoRastreio"
          class="body-2 pt-5 white--text"
          readonly
          :value="`${codigoRastreio}`"
        />
      </v-btn>
    </v-alert>

    <p
      v-else
      class="mb-0 grey--text text--darken-2"
      data-cy="label_texto_codigo_rastreio"
    >
      <template v-if="!transportadoraOutros">
        O código de rastreio foi gerado! Você pode acompanhar o trajeto da
        encomenda pela transportadora <strong>{{ transportadoraNome }}</strong>.
      </template>
      <template v-else>
        Você pode acompanhar o estado de envio da sua compra pelo código de
        rastreio com a transportadora <strong>{{ transportadoraNome }}</strong>.
      </template>
    </p>
    <v-btn
      v-if="!mostrarUltimoStatus"
      text
      class="pa-0 my-2 primary--text"
      data-cy="btn_codigo_rastreio"
      @click="copiarCodigoRastreio"
    >
      <v-icon
        class="mr-2"
      >
        mdi-content-copy
      </v-icon>
      <v-text-field
        ref="codigoRastreio"
        :value="`${codigoRastreio}`"
        class="body-2 pt-5 primary--text"
        readonly
      />
    </v-btn>

    <v-btn
      v-if="!transportadoraOutros"
      class="mb-1"
      color="primary"
      data-cy="btn_acompanhar_envio"
      label
      outlined
      :block="mostrarUltimoStatus"
      :to="`/acompanhar-envio/${vendaId}`"
      @click="$emit('gravar-compra-store'); scoreConsumidor(vendaId)"
    >
      Acompanhar Envio
    </v-btn>

    <SnackBar
      mensage="Código de rastreio copiado"
      :snackbar="snackBar"
      :button="true"
      color="success"
      :timeout="7000"
      @changeSnackBar="value => this.snackBar = value.visible"
    />
  </div>
</template>

<script>
import SnackBar from '@/components/SnackBar.vue';
import ApiCompras from '@/api/compras';
import ApiScoreConsumidor from '@/api/scoreConsumidor';

export default {

  name: 'InfoAcompanharEnvio',

  components: {
    SnackBar,
  },

  props: {
    codigoRastreio: {
      type: String,
      required: true,
    },

    servicoRastreio: {
      type: String,
      required: true,
    },

    mostrarUltimoStatus: {
      type: Boolean,
      default: false,
    },

    vendaId: {
      type: Number,
      required: true,
    },
    transportadoraNome: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      snackBar: false,
      dadosRastreio: null,
      loadingRastreio: true,
    };
  },

  computed: {
    rastreioValido() {
      return this.dadosRastreio && this.dadosRastreio.data && this.dadosRastreio.data.length > 0;
    },
    ultimoStatusRastreio() {
      return this.rastreioValido
        ? this.dadosRastreio.data[0].description
        : 'No momento não foi possível obter o status. Tente mais tarde, por favor.';
    },

    statusRastreioEntregue() {
      return this.rastreioValido && this.dadosRastreio.data[0].status === 'delivered';
    },

    corStatusRastreio() {
      return this.statusRastreioEntregue ? 'success' : 'warning';
    },

    iconeStatusRastreio() {
      return this.statusRastreioEntregue ? 'check_circle' : 'error';
    },
    transportadoraOutros() {
      return !this.servicoRastreio;
    },
  },

  created() {
    if (this.mostrarUltimoStatus) {
      this.buscarDadosRastreio();
    }
  },

  methods: {
    async buscarDadosRastreio() {
      await ApiCompras.orderTracking(this.codigoRastreio, this.servicoRastreio)
        .then((response) => {
          this.dadosRastreio = response.data;
        })
        .finally(() => {
          this.loadingRastreio = false;
        });
    },

    copiarCodigoRastreio() {
      const codigo = this.$refs.codigoRastreio.$el.querySelector('input');
      codigo.select();
      document.execCommand('copy');
      this.snackBar = true;
    },

    async scoreConsumidor(orderId) {
      await ApiScoreConsumidor.scoreConsumidor('tracking', orderId);
    },
  },
};
</script>
